"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedRibbon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const store_1 = require("@completeanatomy/store");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const hocs_1 = require("../../hocs");
const CardContent_1 = require("../../molecules/CardContent");
const ContentBig_1 = require("../../molecules/ContentBig");
const ContentLandscape_1 = require("../../molecules/ContentLandscape");
const providers_1 = require("../../providers");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line max-lines-per-function
function LicenseCard({ license }) {
    const isLandscape = (0, ui_1.useOrientation)();
    const { isMobile, isWindows } = (0, device_1.usePlatform)();
    const isCN = (0, device_1.useIsCNRegion)();
    const theme = (0, styled_components_1.useTheme)();
    const bridge = (0, bridge_1.useBridge)();
    const inappStoreService = (0, providers_1.useInappStoreService)();
    const currentUser = (0, user_1.useUser)();
    const storeState = (0, store_1.useStoreState)();
    const recommendedType = storeState.recommendedLicenseType;
    const recommended = license.type === recommendedType;
    const isEdu = license.type === bridge_schema_1.LicenseType.Edu;
    const buttonRef = (0, react_1.useRef)(null);
    const onBuy = (0, react_1.useCallback)(() => {
        if (isWindows) {
            let link = '';
            switch (license.type) {
                case bridge_schema_1.LicenseType.StudentPlus:
                    link = 'https://store.3d4medical.com/checkout/student?promo=windows';
                    break;
                case bridge_schema_1.LicenseType.Pro:
                    link = 'https://store.3d4medical.com/checkout/pro?promo=windows';
                    break;
                default:
                    break;
            }
            if (isCN) {
                link = link.replace('3d4medical.com', 'completeanatomy.cn');
            }
            bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link });
            return;
        }
        if (license === null || license === void 0 ? void 0 : license.product) {
            if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier)) {
                //@ts-ignore -- navigates back to store page.
                window.navigateBack = true;
            }
            inappStoreService === null || inappStoreService === void 0 ? void 0 : inappStoreService.sendSubscriptionAddedToCartEvent(license === null || license === void 0 ? void 0 : license.product);
            // @ts-ignore
            window.Manager.InAppPurchaseManager.purchaseProductWithOptions({
                productIdentifier: license.product.identifier,
            });
        }
    }, [
        bridge,
        isCN,
        isWindows,
        license,
        inappStoreService,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.identifier,
    ]);
    const onEduClick = () => {
        // @ts-ignore - @todo replace
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: window.INSTITUTIONAL_URL });
    };
    const Container = isMobile ? ContainerMobile : ContainerDesktop;
    const openBuyLicense = license.product && !license.isPurchased && license.type !== bridge_schema_1.LicenseType.Edu;
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: buttonRef, recommended: recommended, big: isEdu, onClick: openBuyLicense ? onBuy : onEduClick, "data-e2e": 'LicenseCard_Container', children: [isEdu ? ((0, jsx_runtime_1.jsx)(ContentBig_1.ContentBig, { license: license, "data-e2e": 'LicenseCard_ContentBig' })) : isMobile && isLandscape ? ((0, jsx_runtime_1.jsx)(ContentLandscape_1.ContentLandscape, { license: license, onBuy: onBuy, "data-e2e": 'LicenseCard_ContentLandscape' })) : ((0, jsx_runtime_1.jsx)(CardContent_1.CardContent, { license: license, onBuy: onBuy, "data-e2e": 'LicenseCard_CardContent' })), !!license.isPurchased && ((0, jsx_runtime_1.jsx)(ui_1.Ribbon, { title: (0, i18n_1.Localized)(i18n_1.Strings.store.purchased), color: theme.gray, "data-e2e": 'LicenseCard_Ribbon' })), recommended && ((0, jsx_runtime_1.jsx)(exports.RecommendedRibbon, { "data-e2e": 'LicenseCard_RecommendedRibbon', children: (0, i18n_1.Localized)(i18n_1.Strings.store.recommended) }))] }));
}
exports.default = (0, hocs_1.withInappStoreProvider)(LicenseCard);
const Container = styled_components_1.default.div `
  position: relative;
  display: flex;
  box-sizing: border-box;
  min-height: 350px;
  margin: 10px 30px;
  padding-top: ${props => (props.recommended ? '15px' : '0')};
  overflow: hidden;

  background-color: ${props => props.recommended
    ? props.theme.store.recommendedBackground
    : props.theme.backgroundSenary};

  border: ${props => props.recommended ? `solid 1px ${props.theme.green}` : 'none'};

  ${({ big, theme }) => big &&
    (0, styled_components_1.css) `
      background-color: ${theme.background};
      border-color: ${theme.thinLine};
    `};

  border-radius: 2px;
  box-shadow: ${props => props.theme.store.buttonShadow};
  cursor: pointer;
`;
const ContainerMobile = (0, styled_components_1.default)(Container) `
  flex-direction: column;

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    flex-direction: row;
    justify-content: space-between;
    min-height: 150px;
    margin: 10px 20px;
  `)};
`;
const ContainerDesktop = (0, styled_components_1.default)(Container) `
  flex-direction: column;
  width: ${props => (props.big ? '420px' : '210px')};
  min-height: 310px;
  margin: 10px;
`;
exports.RecommendedRibbon = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;
  color: ${props => props.theme.white};
  font-size: 11px;
  text-align: center;
  background: ${props => props.theme.green};
`;
